
export const NAME_LIST = new Array(
	"農家",
	"家庭菜園(自宅/庭)",
	"家庭菜園(畑)",
	"専門家(種苗/農薬)",
	"専門家(仕入業者)",
	"専門家(その他)",
	"料理人",
	"一般"
)

export const ICON_LIST = new Array(
	"",					// 未設定
	"img/icon/category_1.png",
	"img/icon/category_2.png",
	"img/icon/category_2.png",
	"img/icon/category_3.png",
	"img/icon/category_3.png",
	"img/icon/category_3.png",
	"img/icon/category_4.png",
	""
)
